module.exports = __webpack_public_path__ + "static/media/BDS1.78e53f5b.pdf";